import { Request } from 'api';
import { AxiosResponse } from 'axios';
import { AllSubmissionsResponse } from 'utils';

type ReturnType = Promise<AxiosResponse<AllSubmissionsResponse>>;

const viewAllSubmissions = (query = {}): ReturnType => {
    return Request.get(`/data/submissions`, {
        params: query,
    });
};
export default viewAllSubmissions;
